import {
    ResponsiveContainer,
    ComposedChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label
} from 'recharts';
import { Box, Grid, Typography } from '@mui/material';
import { filterBarKeysIfNoData, formatGraphAxis, formatLegend, BarGraphTooltip, formatTicker } from '../utils/graph-utils';
import { legendHeight, legendIconSize, stackedContainerWidth, stackedGraphFontSize, barSize, stackedBarCategoryGap, responsiveContainerHeight, groupColors, composedChartMarginForStackedGraph, maxGraphBoxWidth, chartOffset } from '../constants/graph-constants';
import NoGraphData from './NoGraphData';

export default function GroupStackedBarGraph({ stackedBarGraphData, year, type, companyName, unit, groupArray }) {
    return (
        <NoGraphData data={stackedBarGraphData} year={year} type={type} variant={'stacked-bar-graph'}>
            <Grid xs={12} item display="flex" justifyContent={'center'} mb={'3rem'}>
                <StackedBarGraphForGroups data={stackedBarGraphData} year={year} type={type} companyName={companyName} unit={unit} groupArray={groupArray} />
            </Grid>
        </NoGraphData >
    );
}

function StackedBarGraphForGroups({ data, year, type, companyName, unit, groupArray }) {

    const barKeys = groupArray.map((group) => (group))
    const filteredBarKeys = filterBarKeysIfNoData(barKeys, data);
    const sortedAndFilteredBarKeys = filteredBarKeys?.slice().sort((a, b) => a.localeCompare(b))

    return (
        <Box sx={{ width: '100%', height: '100%', maxWidth: maxGraphBoxWidth }}>
            <Typography variant="h6" align="center" gutterBottom>
                {companyName} {type} {year}
            </Typography>
            <ResponsiveContainer width={stackedContainerWidth} height={responsiveContainerHeight} style={{ justifySelf: 'center' }} >
                <ComposedChart data={data} margin={composedChartMarginForStackedGraph} barSize={barSize} barCategoryGap={stackedBarCategoryGap}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="category"
                        fontSize={stackedGraphFontSize}
                        tickFormatter={label => label.length > 13 && type === 'Purchased Capital Goods and Services' ? label.slice(0, 13) + '…' : label}
                    />
                    <YAxis
                        fontSize={stackedGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label angle={-90} value={unit} position={'insideLeft'} offset={chartOffset} fontSize={stackedGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<BarGraphTooltip reversed={true} />} />
                    <Legend formatter={formatLegend} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    {sortedAndFilteredBarKeys?.map(barKey => (
                        <Bar
                            key={barKey}
                            stackId={1}
                            dataKey={barKey}
                            fill={groupColors[barKey] || '#ccc'}
                            name={barKey}
                        />
                    ))}
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    )
}